<template>
  <div>
    <Banner
      :titulo="banner.title"
      :image="banner.image"
      :respimage="banner.resp_image"
    />
    <section class="Blog bg-white">
      <div class="container">
        <article>
          <div
            class="container-publication"
            v-for="publication in post"
            v-if="post.length > 0"
          >
            <div class="date-publication">
              <span class="month"> {{ publication.post_date_month }} </span>
              <span class="day">{{ publication.post_date_day }}</span>
            </div>

            <h2
              class="title-publication"
              @click="toPublication(publication.slug)"
            >
              <router-link
                :to="{
                  name: 'detailsblog',
                  params: { slug: publication.slug }
                }"
                >{{ publication.title }}</router-link
              >
              <div>por: {{ publication.author }}</div>
            </h2>

            <div class="space-publication"></div>
            <div class="text-publicacation">
              <div v-html="publication.resume">{{ publication.resume }}</div>
              <div class="more">
                <router-link
                  :to="{
                    name: 'detailsblog',
                    params: { slug: publication.slug }
                  }"
                  >Leia mais
                </router-link>
              </div>
            </div>

            <figure>
              <img
                :src="publication.image"
                :alt="publication.title"
                width="350"
              />
            </figure>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";

import Banner from "../shared/Banner";
import BlogService from "../../domain/BlogService";
import BannerService from "../../domain/bannerService";

export default {
  props: [],
  components: {
    Banner
  },
  watch: {
    "$i18n.locale": function() {
      this.init();
    }
  },
  data() {
    return {
      titulo: "Blog",
      image: "/static/blog.png",
      post: [],
      banner: []
    };
  },

  methods: {
    init() {
      Vue.http.headers.common["Content-Language"] = this.$i18n.locale;

      this.serviceBlog.Blog().then(res => {
        this.post = res;
        return this.post;
      });

      this.bannerService = new BannerService(this.$resource, "BLOG");

      this.bannerService.blocks().then(res => {
        this.banner = res;
        this.banner = this.banner[0];
        return this.banner;
      });
    }
  },

  created() {
    this.serviceBlog = new BlogService(this.$resource);
    this.init();
  }
};
</script>

<style lang="scss">
.Blog {
  padding: 60px 0;

  .bnt-voltar {
    flex-basis: calc(100% - 60px);
    border-top: 1px solid #ccc;
    margin: 70px 0;
    text-align: center;

    a {
      display: inline-block;
      color: #ffffff;
      background: #3ab8e8;
      padding: 15px 50px;
      margin-top: 50px;
      font-size: 15px;
      border-radius: 6px;
    }
  }

  article {
    margin-top: 80px;
  }

  .container-publication {
    flex-basis: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;
    justify-content: center;

    .space-publication {
      flex-basis: 60px;
    }

    .date-publication {
      flex-basis: 60px;
      border: 1px solid #1c3e73;
      background: #1c3e73;
      text-align: center;
      user-select: none;
      padding: 8px 0;

      span {
        color: #ffffff;
        display: block;

        &.month {
          font-size: 14px;
          font-style: italic;
        }

        &.day {
          font-size: 22px;
        }
      }
    }

    h2.title-publication {
      flex-basis: calc(100% - 80px);
      margin-left: 20px;
      font-weight: normal;
      font-style: italic;

      a {
        font-size: 34px;
        color: #333333;
        text-decoration: none;
      }
    }

    .content-publication {
      flex: 92%;
      margin: 20px 0 0 20px;
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      padding-right: 10px;
      text-align: justify;
    }

    .text-publicacation {
      flex-basis: calc(100% - 430px);
      margin: 20px 0 0 20px;

      p {
        width: 92%;
        font-size: 16px;
        color: #333333;
        line-height: 30px;
        padding-right: 10px;
        text-align: justify;
      }
    }

    .more {
      display: block;
      width: calc(100% - 100px);
      text-align: left;

      a {
        width: 120px;
        height: 50px;
        line-height: 50px;
        color: #ffffff;
        display: block;
        background: #3ab8e8;
        border-radius: 6px;
        font-size: 17px;
        margin: 20px 0 40px 0;
        font-weight: normal;
        border: 1px solid #3ab8e8;
        text-align: center;
      }
    }

    figure {
      flex-basis: 350px;
      height: 230px;
      margin-top: 30px;
    }
  }
}

@media (max-width: 640px) {
  .Blog {
    article {
      margin-top: 0;
    }
    .container-publication {
      align-items: center;
      margin-bottom: 0;

      h2.title-publication {
        a {
          font-size: 28px;
        }
      }

      .space-publication {
        display: none;
      }

      figure {
        display: none;
      }

      .text-publicacation {
        flex-basis: 100%;
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blog/Blog.vue